import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import './WhatsAppButton.css';

function WhatsAppButton() {
  return (
    <a
      className="whatsapp-button"
      href="https://wa.me/2348034648000"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Let's talk on WhatsApp"
    >
      <span className="whatsapp-button__label" aria-hidden="true">Let's talk</span>
      <span className="whatsapp-button__icon" aria-hidden="true">
        <FaWhatsapp />
      </span>
    </a>
  );
}

export default WhatsAppButton;